<script setup>
import PToggle from '@/components/ProxifyUI/PToggle.vue';
</script>

<template>
  <PToggle class="p-toggle"><slot /></PToggle>
</template>

<style lang="scss">
.p-toggle {
  @apply font-inter text-body-sm font-medium;

  .q-toggle {
    &__inner {
      padding: 0 !important;
      height: unset !important;
      width: unset !important;
      min-width: unset !important;
      &--truthy {
        .q-toggle {
          &__thumb {
            left: 18px !important;
          }
          &__track {
            background-color: $primary-600;
            &:hover {
              background-color: #3c3ed4;
            }
            & {
              opacity: 1;
            }
          }
        }
      }
    }
    &__track {
      transition: background-color 0.2s ease;
      height: 20px !important;
      width: 36px !important;
      border-radius: 12px !important;
      background-color: #f4f5f7;
    }
    &__thumb {
      top: 2px;
      left: 2px;
      width: 16px;
      height: 16px;
      &::after {
        box-shadow:
          0 1px 3px rgba(16, 24, 40, 0.1),
          0 1px 2px rgba(16, 24, 40, 0.06) !important;
      }
      &::before {
        content: none !important;
      }

      & {
        color: #ffffff;
      }
    }

    &__label {
      margin-left: 8px;
    }
  }

  &:focus {
    .q-toggle__track {
      box-shadow: 0 0 0 4px #f4ebff;
    }
  }
}
</style>
